import React from 'react';
import TextInput from '../../form/TextInput';
import Select from '../../form/Select';
import AddressControl from '../../form/AddressControl';
import createForm from "./Form";
import DateTimeInput from "../../form/DateTimeInput";
import {OptionFormatter} from "../../../utils/formatters";
import TextArea from "../../form/TextArea";
import PosItems from "./Purchase/PosItems";
import Button from "../../form/Button";
import classNames from "classnames";
import {postData} from "../../../utils/request";

class purchaseForm extends React.Component {

    render() {
        const isInEdit = this.props.stateType.Modification(this.props.values.state);
        return (
            <form onSubmit={this.props.handleSubmit}>
                <div className="row form-row">
                    <div className="col-sm-3 col-md-push-9">
                        <TextInput
                            {...this.props.getFieldProps(this.props.componentConfig.idfield)}
                            name={this.props.componentConfig.idfield}
                            value={this.props.values[this.props.componentConfig.idfield]}
                            label="Kód"
                            role="idfield"
                        />
                    </div>
                    <div className="col-sm-3 col-md-pull-3">
                        <TextInput
                            {...this.props.getFieldProps("StockOperationState")}
                            disabled="disabled"
                            name="StockOperationState"
                            value={this.props.values.StockOperationState}
                            formatter={OptionFormatter}
                            label="Státusz"/>
                    </div>
                    <div className="col-sm-3 col-md-pull-3">
                        <DateTimeInput
                            {...this.props.getFieldProps("orderdate")}
                            name="orderdate"
                            disabled="disabled"
                            value={this.props.values.orderdate}
                            label="Rögzítés dátuma"
                            showTime={false}
                            saveChanges={this.props.setFieldValue}
                        />
                    </div>

                    <div className="col-sm-3 col-md-pull-3">
                        <label className="control-label">Elszámolás dátuma</label>
                        <div className="input-group">
                            <DateTimeInput
                                {...this.props.getFieldProps("transaction_date")}
                                name="transaction_date"
                                value={this.props.values.transaction_date}
                                label={false}
                                showTime={false}
                                disabled={this.props.values.state > 520 || this.props.isLoading}
                                saveChanges={this.props.setFieldValue}
                            />
                            <div className="input-group-btn">
                                <Button
                                    color={this.props.values.transaction_date === this.props.initialValues.transaction_date ? "default" : "primary"}
                                    disabled={this.props.values.transaction_date === this.props.initialValues.transaction_date || this.props.isLoading}
                                    onClick={async () => {
                                        await this.props.processAction(async () => {
                                            return await postData({
                                                action: this.props.componentConfig.componentname + '.update',
                                                data: {
                                                    [this.props.componentConfig.idfield]: this.props.values[this.props.componentConfig.idfield],
                                                    transaction_date: this.props.values.transaction_date
                                                }
                                            });
                                        });
                                    }}>
                                    Mentés
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
                {this.props.partnerType === "customer" && <div className="row form-row">
                    <div className="col-md-6">
                        <Select
                            {...this.props.getFieldProps("agent")}
                            disabled={"disabled"}
                            objectValue={true}
                            name="agent"
                            component="user"
                            labelKey="name"
                            valueKey="id"
                            storeType="remote"
                            value={this.props.values.agent}
                            saveChanges={this.props.setFieldValue}
                            label="Vevő"
                        />
                    </div>
                    <div className="col-md-6">
                        <TextInput
                            {...this.props.getFieldProps("agent")}
                            disabled="disabled"
                            name="agent.telnum"
                            value={(this.props.values.agent || {}).telnum}
                            label="Telefon"
                        />
                    </div>
                </div>}
                <div className="row form-row">
                    <div className="col-md-3">
                        <Select
                            objectValue={true}
                            name={this.props.partnerType}
                            component="partner"
                            labelKey="name"
                            valueKey="partner_id"
                            storeType="remote"
                            value={this.props.values[this.props.partnerType]}
                            saveChanges={this.props.setFieldValue}
                            label="Partner"
                            disabled={!isInEdit || !(((this.props.values.origin || {}).id === (this.props.values.destination || {}).id) || (this.props.values.destination || {}).id === undefined)}
                            {...this.props.getFieldProps(this.props.partnerType)}
                        />
                    </div>
                    <div className="col-md-6">
                        <div className="row">
                            <AddressControl
                                disabled={"disabled"}
                                name={this.props.partnerType + ".address"}
                                value={(this.props.values[this.props.partnerType] || {}).address}
                                label="Cím"
                                saveChanges={this.props.setFieldValue}
                            />
                        </div>
                    </div>
                    <div className="col-md-3">
                        <TextInput
                            {...this.props.getFieldProps(this.props.partnerType)}
                            disabled="disabled"
                            name={this.props.partnerType + ".telnum"}
                            value={(this.props.values[this.props.partnerType] || {}).telnum}
                            label="Telefon"
                        />
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-md-12">
                        <TextArea
                            {...this.props.getFieldProps("comment")}
                            disabled={!isInEdit}
                            name="comment"
                            value={this.props.values.comment}
                            label="Megjegyzés"
                            saveChanges={this.props.setFieldValue}
                        />
                    </div>
                </div>
                <PosItems {...this.props} />
            </form>
        );
    }
}

export default createForm(purchaseForm);
